<template>
  <div class="user-address-grid">
    <div :dependentComputedProps="{ appConfig }"></div>
    <div
      class="inline-flex align-items-center"
      :class="{
        width80: clientPlatform !== 'Web' && !fullWidth,
        w100: fullWidth,
        pb4: showAddressTooltip,
        mb8: showAddressTooltip,
        'justify-content-between': clientPlatform !== 'Web',
      }"
    >
      <div class="user-address-container" id="user-address-container">
        <span class="user-address-header" @click="handleAddressEdit($event)">
          <i
            class="hkfi-location-line fs-16 color-slaty-dark"
            v-if="
              (addressHeader || bottomAddressLine) && currentOrderType === 'D'
            "
          />
          <img
            :src="staticImgBaseUrl + '/images/global/takeaway-pin.svg'"
            alt="takeaway-pin"
            v-else-if="
              (addressHeader || bottomAddressLine) && currentOrderType !== 'D'
            "
            class="tk-away"
          />
          <div v-else class="loading-sm"></div>
          <span class="complete-address ml4 lh18 fs-12">
            <span
              v-if="isOnLocationPage && addressHeaderOnLocationPage"
              class="bold"
              >{{ addressHeaderOnLocationPage + " " }}</span
            >
            <span v-else-if="addressHeader" class="bold">{{
              addressHeader + " "
            }}</span>
          </span>
          <span>|</span>
        </span>
        <span class="ml4">
          <div class="lh16 comp-address">
            {{ bottomAddressLine }}
          </div>
        </span>
      </div>
      <span v-if="showEllipsis">...</span>
      <span
        @click="
          currentOrderType !== 'D' && isOnLocationPage
            ? changeTakeAwayDineInLocation($event)
            : handleAddressEdit($event)
        "
        class="pl4 fw-800 color-teal-primary address-cta"
        >Change</span
      >
      <onboarding v-if="showOnboarding" data-onboarding-animation="true" />
      <fetch-location v-if="isFirstTimeUser && !showOnboarding" />
      <ask-location
        v-else-if="!isChangeTriggeredFromTakeawayDinein && !showOnboarding"
        class="ask-loc"
      ></ask-location>
    </div>
    <toast-msg
      v-if="showAddressTooltip && clientPlatform !== 'Web'"
      :data-text="modulePropsData?.locationTooltip"
      :data-style="'address-tooltip'"
      :data-text-color="'textWhite'"
    ></toast-msg>
  </div>
</template>

<script>
import AskLocation from "./AskLocation.vue";
import Utility from "./../helpers/utility";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { staticImgBaseUrl, clientPlatform } from "../config/apiEndpoints";
import { keyMapsAction, keyMapsMutation } from "../helpers/storeKeys";
import { EVENT_CLICK_ADDRESS } from "../helpers/analyticsEvents";
import {
  OrderTypesFromCode,
  OrderTypesCode,
} from "../helpers/orderTypesConstants";
import FetchLocation from "./FetchLocation.vue";
import Onboarding from "./Onboarding.vue";
import { FetchLocationKeys } from "./../helpers/addressConstants";
import { setEvents } from "../helpers/analyticsEvents";
import PageNames from "../config/pageNames";

export default {
  name: "HomePageUserAddress",
  props: {
    fullWidth: { required: false, default: true },
    moduleProps: {},
  },
  data() {
    return {
      staticImgBaseUrl,
      clientPlatform,
      modulePropsData: {},
      FetchLocationKeys,
      matchAddress: false,
      showEllipsis: false,
      showOnboarding: LocalStorageFunc.getFirstTimeUser(),
      amplitudeTimeSpentIsNotProcessed: true,
    };
  },
  components: {
    AskLocation,
    FetchLocation,
    Onboarding,
  },
  mounted() {
    this.$store.commit(keyMapsMutation.LOAD_CURRENT_ORDER_TYPE);
    if (this.isLocationPermissionGiven) {
      this.$store.dispatch(keyMapsAction.SAVE_CURRENT_GPS_LOCATION);
    }
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
    if (
      LocalStorageFunc.isLoggedIn() &&
      !LocalStorageFunc.getUserAddresses().length
    ) {
      this.$store.dispatch(keyMapsAction.SAVED_ADDRESSES_API);
    }
    this.autoSelectSavedAddress();
    this.triggerShowEllipsis();
    window.addEventListener("scroll", this.triggerShowEllipsis);
    setTimeout(this.hideOnboarding, 1000);
  },
  methods: {
    handleAddressEdit(e) {
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
        true
      );
      Utility.sendToLocationScreen();
      EVENT_CLICK_ADDRESS();
    },
    hideOnboarding() {
      this.showOnboarding = false;
    },
    changeTakeAwayDineInLocation() {
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
        true
      );
      Utility.sendToLocationScreen({ changeTriggerFromDineinTwy: true });
      EVENT_CLICK_ADDRESS({
        positionWithinSection: 2,
        category: "locality",
      });
    },
    getTimeSpentEventFireTime() {
      return window?._siteProps_?.props?.amplitudeAppLaunchEventFireTime
        ? window?._siteProps_?.props?.amplitudeAppLaunchEventFireTime
        : "3";
    },
    matchSavedAddressWithCurrentLoc(currentLat, currentLng) {
      let addressMatchList = [];
      let enhancedAddressMatchList = [];
      if (this.userAddressList.length) {
        addressMatchList = this.userAddressList?.filter((item) =>
          Utility.checkIfNewLocationMatchesSavedAddress(
            currentLat,
            currentLng,
            item
          )
        );
      }
      if (addressMatchList.length > 1) {
        enhancedAddressMatchList = this.userAddressList?.filter((item) =>
          Utility.checkIfNewLocationMatchesSavedAddress(
            currentLat,
            currentLng,
            item,
            true
          )
        );
      }
      return enhancedAddressMatchList.length
        ? enhancedAddressMatchList[0]
        : addressMatchList.length
        ? addressMatchList[0]
        : false;
    },
    locateMe() {
      this.$store.commit(keyMapsMutation.RESET_LOCATIONSTATE);
      LocalStorageFunc.resetAllSelectedLocations();
      this.$store.dispatch(keyMapsAction.DETECT_CURRENT_LOCATION, {
        showDeliveryMapScreen: false,
        setGeoCode: true,
        triggerTakeAway: this.currentOrderType == OrderTypesCode.TAKEAWAY_CODE,
        triggerDineIn: this.currentOrderType == OrderTypesCode.DINE_IN_CODE,
        setStoreByDefault:
          this.currentOrderType != OrderTypesCode.DELIVERY_CODE,
      });
      if (this.autoSelectUserAddressEnabled) {
        this.autoSelectSavedAddress();
      }
      // this.$store.dispatch(keyMapsAction.SAVE_CURRENT_GPS_LOCATION);
    },
    autoSelectSavedAddress() {
      let selectedUserAddress = this.selectedSavedAddress;
      if (
        !selectedUserAddress &&
        this.currentOrderType === "D" &&
        LocalStorageFunc.isLoggedIn() &&
        this.$store.state.Auth.autoSelectUserAddress &&
        this.currentGPSLocation?.geometry
      ) {
        this.matchAddress = this.matchSavedAddressWithCurrentLoc(
          this.currentGPSLocation.geometry.location.lat,
          this.currentGPSLocation.geometry.location.lng
        );
        if (this.matchAddress) {
          this.$store.commit(
            keyMapsMutation.UPDATE_SELECTED_USER_ADDRESS,
            this.matchAddress
          );
          LocalStorageFunc.setLocalStorageValue(
            "selectedAddress",
            this.matchAddress
          );
          this.$store.commit(
            keyMapsMutation.UPDATE_AUTO_SELECT_USER_ADDRESS,
            false
          );
        }
      }
    },
    triggerShowEllipsis() {
      let el = document.getElementById("user-address-container");
      if (this.showEllipsis != el?.scrollWidth > el?.clientWidth) {
        this.showEllipsis = el?.scrollWidth > el?.clientWidth;
      }
    },
  },
  watch: {
    isLocationPermissionGiven: {
      handler(newVal, oldVal) {
        if (newVal && !oldVal) {
          this.locateMe();
        }
      },
    },
    currentGPSLocationPlaceId: {
      handler(newVal, oldVal) {
        if (newVal && oldVal && newVal !== oldVal) {
          this.locateMe();
        }
      },
    },
  },
  computed: {
    appConfig() {
      if (this.amplitudeTimeSpentIsNotProcessed) {
        this.amplitudeTimeSpentIsNotProcessed = false;
        let eventFireTime = this.getTimeSpentEventFireTime();
        setTimeout(() => {
          setEvents("amplitude", "time_spent", {
            eventCategory: "time spent",
            fired_after: eventFireTime,
            Events_time_stamp: new Date().getTime(),
            Page_Name: PageNames.NEXTGEN_HOMEPAGE,
          });
        }, eventFireTime * 1000); //time in milliseconds
      }
    },
    locationData() {
      return this.$store.state.Location.locationData;
    },
    currentGPSLocationFooterAddress() {
      let currentGPSLoc = this.$store.state.Location.currentGPSLocationData;
      return currentGPSLoc?.footerAddress;
    },
    currentGPSLocationPlaceId() {
      return this.$store.state.Location.currentGPSLocationData?.placeId;
    },
    autoSelectUserAddressEnabled() {
      return this.$store.state.Auth.autoSelectUserAddress;
    },
    isTrueLocationDetected() {
      return this.$store.state.Location.isTrueLocationDetected;
    },
    noDeliveryZoneData() {
      return this.$store.state.Location?.noDeliveryZoneData?.displayText
        ? this.$store.state.Location?.noDeliveryZoneData
        : LocalStorageFunc.getNoDeliveryZoneData();
    },
    addressHeader() {
      if (this.selectedSavedAddress && this.currentOrderType === "D") {
        return this.selectedSavedAddress?.customer_address_name;
      } else if (
        this.isOnHomePage &&
        (!LocalStorageFunc.getDeliveryTypeStationData() ||
          (LocalStorageFunc.getDeliveryTypeStationData() &&
            !Object.keys(LocalStorageFunc.getDeliveryTypeStationData()).length))
      ) {
        return (
          this.lastLocationNewRecent?.footerAddress ||
          this.lastLocationNewRecent?.homePageAddress?.topAddress ||
          this.currentGPSLocation?.displayAddress ||
          this.noDeliveryZoneData?.displayText ||
          "No Location"
        );
      } else if (
        this.isOnHomePage &&
        this.currentOrderType !== "D" &&
        LocalStorageFunc.getDeliveryTypeStationData() &&
        Object.keys(LocalStorageFunc.getDeliveryTypeStationData()).length
      ) {
        return OrderTypesFromCode[this.currentOrderType];
      } else if (
        LocalStorageFunc.getSelectedStore() ||
        this.locationData?.address_alias
      ) {
        return this.locationData.address_alias;
      } else return "No Location";
    },
    addressHeaderOnLocationPage() {
      return OrderTypesFromCode[this.currentOrderType];
    },
    nearestApiTopAddress() {
      return this.$store.state.Location.nearestApiTopAddress;
    },
    currentOrderType() {
      return this.isOnLocationPage
        ? LocalStorageFunc.getSelectedDeliveryType() ||
            this.$store.state.User.currentOrderType
        : this.$store.state.User.currentOrderType;
    },
    isOnHomePage() {
      return Utility.isCurrentlyAtUrl("/store");
    },
    isOnLocationPage() {
      return Utility.isCurrentlyAtUrl("/location");
    },
    showAddressTooltip() {
      if (this.$store.state.Location.addressTooltip) {
        setTimeout(() => {
          this.$store.commit(keyMapsMutation.UPDATE_ADDRESS_TOOLTIP, false);
        }, 1000);
      }
      return this.$store.state.Location.addressTooltip && this.isOnHomePage;
    },
    isChangeTriggeredFromTakeawayDinein() {
      let queryParams = Utility.getQueryFromUrl();
      return queryParams["changeTriggerFromDineinTwy"] == "true" || false;
    },
    isFirstTimeUser() {
      return LocalStorageFunc.getFirstTimeUser();
    },
    userAddressList() {
      return LocalStorageFunc.getUserAddresses().length
        ? LocalStorageFunc.getUserAddresses()
        : this.$store.state.User.savedAddresses;
    },
    selectedSavedAddress() {
      return this.$store.state.User.selectedSavedAddress;
    },
    currentGPSLocation() {
      return this.$store.state.Location.currentGPSLocationData;
    },
    selectedStoreData() {
      return LocalStorageFunc.getSelectedStore();
    },
    isLocationPermissionGiven() {
      return this.$store.state.Location.isLocationPermissionGiven;
    },
    lastLocationNewRecent() {
      return LocalStorageFunc.getLastLocationNew()?.[0]?.recent;
    },
    bottomAddressLine() {
      if (this.selectedSavedAddress && this.currentOrderType === "D") {
        return this.selectedSavedAddress?.formatted_address;
      } else if (
        this.isOnHomePage &&
        (!LocalStorageFunc.getDeliveryTypeStationData() ||
          (LocalStorageFunc.getDeliveryTypeStationData() &&
            !Object.keys(LocalStorageFunc.getDeliveryTypeStationData()).length))
      ) {
        return (
          this.lastLocationNewRecent?.displayAddress ||
          this.currentGPSLocation?.formattedAddress ||
          this.noDeliveryZoneData?.footerText ||
          FetchLocationKeys.EXACT_LOCATION_REQUIRED_TEXT
        );
      } else if (
        this.isOnHomePage &&
        this.currentOrderType !== "D" &&
        this.selectedStoreData &&
        Object.keys(this.selectedStoreData).length
      ) {
        return this.selectedStoreData && this.selectedStoreData?.name
          ? this.selectedStoreData?.name
          : this.$store.state.Location?.locationData?.complete_address;
      } else if (
        this.isOnHomePage &&
        this.currentGPSLocation.formattedAddress
      ) {
        if (this.matchAddress && this.matchAddress?.formatted_address) {
          return this.matchAddress?.formatted_address;
        }
        return this.currentGPSLocation.formattedAddress;
      } else if (this.currentOrderType === "D") {
        return (
          this.selectedSavedAddress?.formatted_address ||
          this.locationData?.complete_address ||
          this.noDeliveryZoneData?.footerText ||
          FetchLocationKeys.EXACT_LOCATION_REQUIRED_TEXT
        );
      } else {
        if (
          this.isChangeTriggeredFromTakeawayDinein &&
          LocalStorageFunc.getSelectedChangedLocationForTwyDinein()
            ?.structuredFormatting
        ) {
          return LocalStorageFunc.getSelectedChangedLocationForTwyDinein()
            ?.structuredFormatting?.mainText;
        } else {
          return (
            this.selectedSavedAddress?.formatted_address ||
            this.locationData?.complete_address ||
            this.lastLocationNewRecent?.displayAddress ||
            this.noDeliveryZoneData?.footerText ||
            FetchLocationKeys.EXACT_LOCATION_REQUIRED_TEXT
          );
        }
      }
    },
  },
};
</script>
